require('./shared')

require('./shared_functions')

require('../../styles/entry/genplus-landing.less')